<app-dashboard-header></app-dashboard-header>

<main>
  <div class="container">
    <div class="content">
      <h2 class="pt-5">المستخدمون</h2>
    <div class="row d-flex justify-content-center align-items-center">
      <div>
        <span class="text">حدد دورًا لإظهار المستخدمين بهذا الدور : </span>
        <select [(ngModel)]="neededRole">
          <option *ngFor="let r of rolesList" value="{{ r._id }}">
            {{ r.type }}
          </option>
        </select>
      </div>
    </div>

    <div class="row d-flex justify-content-center align-items-center mt-5 pb-5">
      <div class="col-lg-8">
        <!-- List group-->
        <ul class="list-group shadow" *ngFor="let p of userList">
          <!-- list group item-->
          <li class="list-group-item mt-3" *ngIf="p.roles.includes(neededRole)">
            <!-- Custom content-->
            <div class="media align-items-lg-center flex-column flex-lg-row p-3">
              <div class="media-body order-2 order-lg-1">
                  <img
                src="https://khairokom-uploadfiles.azurewebsites.net/files/{{
                  p.img
                }}"
                alt="Generic placeholder image"
                width="200"
                class="ml-lg-5 order-1 order-lg-2"
              />
                <h5 class="mt-0 font-weight-bold mb-2">{{ p.userName }}</h5>
                <p class="font-italic text-muted mb-0 small">{{ p.email }}</p>
                <div class="d-flex align-items-center justify-content-between mt-1">
                  <h6 class="font-weight-bold my-2">usererID : {{ p._id }}</h6>
                  <a routerLink="/profile/{{ p._id }}">زيارة الحساب</a>
                  <button class="btn btn-dark" (click)="deleteUser(p._id)">حذف</button>
                </div>
              </div>            
            </div>
            <!-- End -->
          </li>
          <!-- End -->
        </ul>
        <!-- End -->
      </div>
    </div>
    </div>
  </div>
</main>

<app-dashboard-footer></app-dashboard-footer>